import type { ButtonHTMLAttributes, ReactNode, Ref } from "react";

import { cn } from "@/lib/cn";

type Variant = "default" | "active" | "danger" | "stage";

const VARIANTS: Record<Variant, string> = {
  default: "text-ink-muted not-disabled:hover:bg-surface-raised not-disabled:hover:text-ink",
  active: "bg-brand text-brand-ink not-disabled:hover:bg-brand-strong",
  danger: "bg-danger text-white not-disabled:hover:bg-danger-strong",
  stage: "text-stage-ink/80 not-disabled:hover:bg-stage-wash not-disabled:hover:text-stage-ink",
};

export type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  label: string;
  variant?: Variant | undefined;

  ref?: Ref<HTMLButtonElement> | undefined;
  children: ReactNode;
};

export function IconButton({
  label,
  variant = "default",
  className,
  children,
  type = "button",
  ...rest
}: IconButtonProps) {
  return (
    <button
      aria-label={label}
      className={cn(
        "inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl transition-colors disabled:opacity-40",
        VARIANTS[variant],
        className,
      )}
      title={label}
      type={type}
      {...rest}
    >
      {children}
    </button>
  );
}
